import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsErrorBoundary, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { FCC } from './lib/types';

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    enableAutoRouteTracking: true,
    connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING || '',
    extensions: [reactPlugin],
    isBeaconApiDisabled: false,
  },
});

appInsights.addDependencyListener((dep) => {
  dep.context = { ...dep.context, requestBody: dep.init?.body?.toString() || '' };
});

appInsights.addDependencyInitializer((details) => {
  const requestBody = details.context?.requestBody;

  let newProps = { requestBody };
  try {
    const data = JSON.parse(requestBody);
    if (data.operationName) {
      newProps = data;
    }
  } catch (e) {
    // noop: do nothing on JSON error
  }

  details.item.properties = {
    ...details.item.properties,
    ...newProps,
  };
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export const ErrorBoundary: FCC = ({ children }) => (
  <AppInsightsErrorBoundary
    appInsights={reactPlugin}
    onError={() => <div>Something went wrong</div>} // We're yet to plan an error page
  >
    <>{children}</>
  </AppInsightsErrorBoundary>
);

export default appInsights;
